import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from 'react-hook-form';
import { EMAIL_REGEX } from '../../Constants';
import { SkywatchDialog } from '../PopUps/SkywatchDialog';
import FlexView from 'react-flexview/lib';
import NewButtonPopup from '../Core/Buttons/NewButtonPopup';
import { ElevatedCircle } from '../Core/ElevatedCircle';
import policymanagementApi from '../../api/policymanagement.api';
import { addDays, awaitWithLoading } from '../../services/utils';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { PolicyManagementContextStore, ACTIONS } from '../../context/PolicyManagementContext';
import { Action } from '../../models/Action';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { ActiveInsuranceModel } from '../../models/insurance-models/ActiveInsuranceModel';
import { RadioGroup, Radio, FormControlLabel,Select, MenuItem, Grid ,IconButton,InputAdornment,Checkbox} from '@material-ui/core';
import policmanagementImpersonationApi from '../../api/policmanagement.impersonation.api';
import { BlueGrayBox } from "../Core/BlueGrayBox";
import { DatePicker } from '@material-ui/pickers'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import EventIcon from '@material-ui/icons/Event';
import {ModificationApi} from "../../api/modification.api"


export const CancelPolicyPopup = ({onCancel, insuranceId,onConfirm, open,fullRefund = false,policyStartDate }) => {
  const { register, errors, getValues, triggerValidation, control } = useForm()
  const context = React.useContext(PolicyManagementContextStore)
  const [isExtended, setIsExtended] = React.useState(false)
  const [selectedDate, setSelectedDate] = React.useState(new Date())
  const [isNotRefundReq,setIsNotRefundReq] = React.useState(fullRefund)
  const insurance: ActiveInsuranceModel = context.getInsurance(insuranceId)

  const handleClose = () => {
    onCancel && onCancel()
  };
  const handleExtended = () => {
    setIsExtended( !isExtended )
  }

  const onDateChanged = date =>{
      setSelectedDate(new Date(date))
  }

  const Confirm = async () => {
      let valid = await triggerValidation()

      if(!valid) return;
      
      const values = getValues();
      let res ; 
      onConfirm && onConfirm({...values,selectedDate,fullRefund,isNotRefundReq},insurance);
  }
  return (
      <SkywatchDialog
            open={open}
            closeDialog={handleClose}
            closeTitle="Additional Insured"
            maxWidth={'sm'}>
            <div className="full-width">
                <div className="modify-title">Cancel Policy - {fullRefund ? 'Flat':'Pro Rata' }</div>
                <div style={{marginBottom: '20px'}}>Please add the following details to policy number {insurance.policyNumber}</div>
                <Grid container item xs={12} spacing={2}>
                    {!fullRefund &&<Grid item xs={6}>
                        <DatePicker
                                name="cancelationDate"
                                variant="inline"
                                inputVariant="outlined"
                                label="Cancel Date"
                                id="cancelation_date"
                                style={{width: '100%'}}
                                minDate={policyStartDate}
                                disableFuture
                                value={selectedDate}
                                className="clickable"
                                inputRef={register}
                                onChange={onDateChanged}
                                format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
                                InputProps={{ disableUnderline: true, className: 'lightgrayblue', endAdornment: <InputAdornment>
                                <IconButton className="lightgrayblue">
                                    <EventIcon fontSize={'small'} className="lightgrayblue" />
                                </IconButton>
                            </InputAdornment> }}
                            />
                            
                    
                    </Grid>}

                    <Grid item xs={fullRefund ? 12 : 6}>
                        <Controller
                        rules={{ validate: (field) => !!field }}
                        name="cancellationReason"
                        className="cancel-reason"
                        control={control}
                        error={!!errors.cancellationReason}
                        helperText={
                            !!errors.cancellationReason && "Cancellation reason is required"
                        }
                        as={
                            <TextField label="Cancellation Reason" fullWidth select variant="outlined">
                            <MenuItem value="AccidentallyPurchased">Purchased by mistake</MenuItem>
                            <MenuItem value="ReplacementRequest">Replacement Request</MenuItem>
                            <MenuItem value="DontWantGlobalRenewal">Did not want to renew with Global</MenuItem>
                            <MenuItem value="SystemFault">System Fault</MenuItem>
                            <MenuItem value="UnwantedRenewal">Did not want auto-renew</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                            </TextField>
                        }
                    />
                    </Grid>
                </Grid>

                <Grid container item xs={12} spacing={2}>
                    <Grid item xs={12}>
                        <TextField 
                                fullWidth variant="outlined" 
                                label="Comments" 
                                name="comments" 
                                control={control}
                                error={!!errors.comments}
                                helperText={
                                    !!errors.comments && "Comment is required"
                                }
                                inputRef={register({required: true})} 
                                />
                    </Grid>
                </Grid>
            
                <Grid container item xs={12} spacing={2}>
                <FormControlLabel
                className="margin-bottom-small"
                name="is_refund"
                control={
                    <Checkbox
                    control={control}
                    checked={isNotRefundReq}
                    inputRef={register({required: false})}
                    name="is_not_refund"
                    color="primary"
                    onChange={() => {
                        setIsNotRefundReq(!isNotRefundReq);
                    }}
                    />
                }
                label="Cancel without refund"
                />
                </Grid>
                <FlexView vAlignContent={'center'} className="space-between actions-footer">
                    <NewButtonPopup withFill={false} onClick={handleClose}>Cancel</NewButtonPopup>
                    <NewButtonPopup withFill={true} onClick={async ()=>{Confirm()}}>Cancel Policy</NewButtonPopup>
                </FlexView>
            </div>
        </SkywatchDialog>
  );
}